import { minLength, required } from "vuelidate/lib/validators"

export const phoneNumberValidation = {
  required,
  minLength: minLength(14),
}
